module.exports = __webpack_public_path__ + "media/images/mobile/mb-hamburger-blue-425715e82b78d3a46522b71a98bd3c72.png";